/**
 * The posted field naming the Book a meeting button a booking or request came
 * from, the `Source` its `BookMeetingReveal` reported (e.g. `ProjectIsland`).
 */
export const CTA_SOURCE_FIELD = 'ctaSource';

const CTA_SOURCE_PATTERN = /^[A-Za-z0-9_-]{1,100}$/;

/**
 * A posted button source, kept only when it is a plain identifier: it labels
 * the meeting's analytics events and nothing else, so anything else is dropped
 * rather than refused.
 */
export function parseCtaSource(value: unknown): string | undefined {
    if (typeof value !== 'string') return undefined;
    const source = value.trim();
    return CTA_SOURCE_PATTERN.test(source) ? source : undefined;
}
